module.exports = __webpack_public_path__ + "img/banner-01.24e8ad4c.jpg";